module.exports = __webpack_public_path__ + "img/176-lesotho.b5cc6d5b.svg";